import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateInstrumentSubtypeCommand extends ValueObject {
    
    public staticInstrumentSubTypeID: number = 0;

    @Rules.Required()
    public staticInstrumentTypeID: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public instrumentSubTypeName: string = "";
}